/* eslint-disable import/first */
/* eslint-disable linebreak-style */
import { switchLanguage, toggleCollapsedNav, resetApp, requestCustomerData, fillCustomerProfileDetails } from "actions";
import { withRouter, Link } from "react-router-dom";
import { connect } from "react-redux";
import { isWebview } from '../../util/generalFunction'
import { Dropdown, DropdownMenu, DropdownToggle } from "reactstrap";
import {
  COLLAPSED_DRAWER,
  FIXED_DRAWER,
  HORIZONTAL_NAVIGATION,
  INSIDE_THE_HEADER,
} from "constants/ActionTypes";
import React from "react";
import SearchBox from "components/SearchBox";
import AppNotification from "../AppNotification/index";
import CardHeader from "components/dashboard/Common/CardHeader/index";
import IntlMessages from "util/IntlMessages";
import LanguageSwitcher from "components/LanguageSwitcher/index";
import UserInfo from "components/CustomerUserInfo";
import Menu from "components/Header/Menu";
import MailNotification from "../MailNotification/index";
import logo from "assets/images/vibo_vibo-white-new.png";
import HeaderDrawer from "components/Drawer";
import navIcon from "../../assets/images/hamburger.svg";

class Header extends React.Component {
  componentDidMount(){
    const user = JSON.parse(localStorage.getItem("user-data"));

    if (user) {
      if (user.role.name == "Customer") {
        this.props.requestCustomerData();
        this.props.fillCustomerProfileDetails();
      }
      // user ? (user.role.name == "Customer" ? this.props.requestCustomerData()  this.props.fillCustomerProfileDetails() : null) : null;
    }
  }
  onAppNotificationSelect = () => {
    this.setState({
      appNotification: !this.state.appNotification,
    });
  };
  onMailNotificationSelect = () => {
    this.setState({
      mailNotification: !this.state.mailNotification,
    });
  };

  onUserInfoSelect = () => {
    this.setState({
      userInfo: !this.state.userInfo,
    });
  };

  onLangSwitcherSelect = event => {
    this.setState({
      langSwitcher: !this.state.langSwitcher,
    });
  };
  onSearchBoxSelect = () => {
    this.setState({
      searchBox: !this.state.searchBox,
    });
  };

  toggle = () => {
    this.setState({ top: true });
    if (this.state.top === true) {
      this.setState({ top: false });
    }
  };
  handleRequestClose = () => {
    this.setState({
      langSwitcher: false,
      mailNotification: false,
      appNotification: false,
      searchBox: false,
    });
  };
  onToggleCollapsedNav = e => {
    const val = !this.props.navCollapsed;
    this.props.toggleCollapsedNav(val);
  };

  onOpenChange = () => {
    this.setState({
      top: false,
    });
  };

  constructor() {
    super();
    this.state = {
      searchBox: false,
      searchText: "",
      mailNotification: false,
      langSwitcher: false,
      appNotification: false,
      userInfo: false,
      top: false,
    };
  }

  updateSearchText(evt) {
    this.setState({
      searchText: evt.target.value,
    });
  }

  render() {
    const { drawerType, locale, navigationStyle, horizontalNavPosition } = this.props;
    const drawerStyle = drawerType.includes(FIXED_DRAWER)
      ? "d-flex d-xl-none"
      : drawerType.includes(COLLAPSED_DRAWER)
      ? "d-flex"
      : "d-none";

    const user = JSON.parse(localStorage.getItem("user-data"));

    return (
      <div className="app-header">
        {user ? user.role.name === "Customer" ? null : <HeaderDrawer top={this.state.top} onOpenChange={this.onOpenChange} /> : <HeaderDrawer top={this.state.top} onOpenChange={this.onOpenChange} />}
        <div className="app-main-header-customer">
          <div className="d-flex app-toolbar align-items-center">
            <div style={{ margin: "0" }} className="app-logo pointer d-md-block">
              <Link to="/" exact="true">
                <img className="d-block" alt="..." src={logo} />
              </Link>
            </div>
              {/* <li className="d-lg-inline-block d-none list-inline-item mr-5">
                <Link className="nav-link" to="">
                <p className="nav-text text-transform-none">Login</p>
                </Link>
              </li> */}
              {user ? user.role.name === "Customer" ? 
                // <div className="list-inline ml-auto text-center">
                //   <DropdownMenu right>
                //     <UserInfo resetApp={this.props.resetApp} />
                //   </DropdownMenu>
                // </div>
                <ul className="header-notifications list-inline ml-auto">
                  <li className="list-inline-item user-nav">
                    <Dropdown
                      className="quick-menu"
                      isOpen={this.state.userInfo}
                      toggle={this.onUserInfoSelect.bind(this)}
                    >
                      <DropdownToggle className="d-inline-block" tag="span" data-toggle="dropdown" style={{color: '#fff', fontSize: '15px', cursor: 'pointer'}}>
                        {/* <img
                          alt="..."
                          src={user.business && user.business.logo ? user.business.logo.url : "https://via.placeholder.com/150x150"}
                          className="pointer user-avatar size-30"
                        /> */}
                      {`Hi ${this.props.firstname} ${this.props.lastname}` || `${this.props.username}`}<i className="zmdi zmdi-caret-down zmdi-hc-fw mr-1" />
                      </DropdownToggle>

                      <DropdownMenu right>
                        <UserInfo resetApp={this.props.resetApp} />
                      </DropdownMenu>
                    </Dropdown>
                  </li>
                </ul>
              : <ul style={{ margin: "0" }} className="list-inline ml-auto text-center">
              {/* <li className="d-lg-inline-block d-none list-inline-item mr-5">
                <Link className="nav-link" to="/signup">
                  <p className="nav-text text-transform-none">SIGN UP</p>
                </Link>
              </li> */}
              <li className="list-inline-item user-nav">
                    <Dropdown
                      className="quick-menu"
                      isOpen={this.state.userInfo}
                      toggle={this.onUserInfoSelect.bind(this)}
                    >
                      <DropdownToggle className="d-inline-block" tag="span" data-toggle="dropdown" style={{color: '#fff', fontSize: '15px', cursor: 'pointer'}}>
                        {/* <img
                          alt="..."
                          src={user.business && user.business.logo ? user.business.logo.url : "https://via.placeholder.com/150x150"}
                          className="pointer user-avatar size-30"
                        /> */}
                      {`Hi ${user.firstname} ${user.lastname}` || `${user.username}`}<i className="zmdi zmdi-caret-down zmdi-hc-fw mr-1" />
                      </DropdownToggle>

                      <DropdownMenu right>
                        <UserInfo resetApp={this.props.resetApp} />
                      </DropdownMenu>
                    </Dropdown>
                  </li>
              {/* <li className="d-lg-inline-block d-none list-inline-item mr-5 mt-3">
                {user ? user.role.name == 'Business Owner' ?
                <Link className="nav-link" to="/admin/appointments">
                  <p className="nav-text text-transform-none">Business Owners</p>
                </Link>: <Link className="nav-link" to="/super-admin/businesses">
                  <p className="nav-text text-transform-none">Super Admin</p>
                </Link> : null}
                <Link className="nav-link" to="/logout">
                  <p className="nav-text text-transform-none">LOG OUT</p>
                </Link>
              </li> */}
            </ul> :
                <ul style={{ margin: "0" }} className="list-inline ml-auto text-center">
                  <li className="d-lg-inline-block d-none list-inline-item mr-5">
                    <Link className="nav-link" to="/signup">
                      <p className="nav-text text-transform-none">SIGN UP</p>
                    </Link>
                  </li>
                  <li className="d-lg-inline-block d-none list-inline-item mr-5 mt-3">
                    <Link className="nav-link" to="/login">
                      <p className="nav-text text-transform-none">LOG IN</p>
                    </Link>
                  </li>
                </ul>
              }
            {/* <span
              className="jr-menu-icon header-right pointer d-flex d-lg-none d-xl-none"
              onClick={this.toggle}
            >
              <span className="menu-icon" />
            </span> */}
            {
      
        (
          // isWebview() ? null :
           user ? null : <span className="navbar-toggler-icon header-right pointer" onClick={this.toggle} > <span className="navbar-toggler-icon" /> </span>
           
           )
           
        }
          </div>
        </div>
      </div>

/* <nav class="navbar navbar-dark navbar-expand-lg fixed-top bg-dark navbar-custom">
        <div class="container"><a class="navbar-brand" href="#"><img class="img-fluid vibo-logo" src="assets/img/vibo_vibo--wordmark-white.svg" alt="Vibo Vibo - Salon Appointments Made Easy"></a><button class="navbar-toggler" data-toggle="collapse" data-target="#navbarResponsive"><span class="navbar-toggler-icon"></span></button>
            <div
                class="collapse navbar-collapse" id="navbarResponsive">
                <ul class="nav navbar-nav ml-auto">
                    <li class="nav-item" role="presentation"><a class="nav-link" href="#">Sign Up</a></li>
                    <li class="nav-item" role="presentation"><a class="nav-link" href="#">Log In</a></li>
                </ul>
        </div>
        </div>
    </nav> *///   <nav className="navbar navbar-dark navbar-expand-lg fixed-top bg-dark navbar-custom">
    //     {/* <HeaderDrawer top={this.state.top} onOpenChange={this.onOpenChange} /> */}
    //     <div className="container">
    //       <a className="navbar-brand" href="#"><img className="img-fluid vibo-logo" src={logo} alt="Vibo Vibo - Salon Appointments Made Easy" /></a>
    //       <button data-toggle="collapse" className="navbar-toggler" data-target="#navbarResponsive" onClick={this.toggle}>
    //         <span className="navbar-toggler-icon"></span>
    //       </button>
    //         <div
    //             className="collapse navbar-collapse" id="navbarResponsive">
    //             <ul className="nav navbar-nav ml-auto">
    //                 {/* <li className="nav-item" role="presentation"><a className="nav-link" href="#">Sign Up</a></li> */}
    //                 {/* <li className="nav-item" role="presentation"><a className="nav-link" href="#">Log In</a></li> */}
    //                 <li className="d-lg-inline-block d-none list-inline-item mr-5 mt-3">
    //                 <Link className="nav-link" to="/login">
    //                   <p className="nav-text text-transform-none">Business Owners</p>
    //                 </Link>
    //                 </li>
    //             </ul>
    //     </div>
    //     </div>
    // </nav>
    );
  }
}

const mapStateToProps = ({ settings, customerProfile }) => {
  const { drawerType, locale, navigationStyle, horizontalNavPosition } = settings;
  const { firstname, lastname, username } = customerProfile.customerProfile;
  return { drawerType, locale, navigationStyle, horizontalNavPosition, firstname, lastname, username };
};

export default withRouter(
  connect(
    mapStateToProps,
    { toggleCollapsedNav, switchLanguage, resetApp, requestCustomerData, fillCustomerProfileDetails }
  )(Header)
);



// WEBPACK FOOTER //
// ./components/Header1/index.js